<template>
    <div class="email-listing">
        <div class="email-listing__heading">
            <h1>{{ $t.__('email.EmailListing.title') }}</h1>
            <CompassButton
                v-if="onOutboxPage && emailsNotEmpty"
                :label="$t.__('email.EmailListing.resend_failed_emails')"
                leftIcon="reload"
                @click="handleResendFailedEmails"
            />
        </div>

        <router-view v-if="isProvidersErrorPage" :key="$route.path"></router-view>

        <LayoutWithNavigation v-else>
            <template slot="navigation">
                <CompassSideNav :menuItems="formattedNavItems" />
            </template>

            <template slot="default">
                <router-view :key="$route.path" @emails-status="updateEmailsStatus"></router-view>
            </template>
        </LayoutWithNavigation>
    </div>
</template>
<script>
import Feature from 'Services/Feature';
import LayoutWithNavigation from 'vcomponents/common/layout/LayoutWithNavigation.vue';
import { rensendAllFailedEmails } from 'api/emailEngine/emailEngineService';

export default {
    components: {
        LayoutWithNavigation,
    },
    data() {
        return {
            emailsNotEmpty: false,
        };
    },
    computed: {
        isProvidersErrorPage() {
            return this.$route.name === 'emails.providers.error';
        },
        isEmailEngineOutboxEnabled() {
            return Feature.isEnabled('email-engine-outbox');
        },
        isSentEmailsEngineEnabled() {
            return (
                Feature.isEnabled('email-engine') &&
                Feature.isEnabled('nylas-api-v3') &&
                Feature.isEnabled('email-engine-sent-emails')
            );
        },
        isReceivedEmailsEngineEnabled() {
            return Feature.isEnabled('email-engine') && Feature.isEnabled('nylas-api-v3');
        },
        onOutboxPage() {
            return this.$route.name === 'emails.outbox' && this.isEmailEngineOutboxEnabled;
        },
        formattedNavItems() {
            const navItemsConfig = [
                {
                    id: 'emails.received',
                    label: this.$t.__('email.EmailListing.received'),
                    routeName: 'emails.received',
                    condition: this.isReceivedEmailsEngineEnabled,
                },
                {
                    id: 'emails.sent',
                    label: this.$t.__('email.EmailListing.sent'),
                    routeName: 'emails.sent',
                    condition: this.isSentEmailsEngineEnabled,
                },
                {
                    id: 'emails.scheduled',
                    label: this.$t.__('email.EmailListing.scheduled'),
                    routeName: 'emails.scheduled',
                    condition: true,
                },
                {
                    id: 'emails.outbox',
                    label: this.$t.__('email.EmailListing.outbox'),
                    routeName: 'emails.outbox',
                    condition: this.isEmailEngineOutboxEnabled,
                },
            ];

            return navItemsConfig
                .filter((item) => item.condition)
                .map((item) => ({
                    id: item.id,
                    label: item.label,
                    active: this.$route.name === item.routeName,
                    route: { name: item.routeName },
                }));
        },
    },
    methods: {
        updateEmailsStatus(emailsNotEmpty) {
            this.emailsNotEmpty = emailsNotEmpty;
        },
        handleResendFailedEmails() {
            rensendAllFailedEmails()
                .then(() => {
                    EventBus.$emit('refreshOutBoxEmailListing');
                })
                .catch((error) => {
                    this.$pushToast({
                        close: true,
                        text: error,
                        type: 'error',
                    });
                });
        },
    },
};
</script>
<style lang="scss" scoped>
.email-listing {
    padding-bottom: var(--spacing-5);

    &__heading {
        display: flex;
        justify-content: space-between;
        margin-bottom: var(--spacing-4);

        h1 {
            margin: 0;
        }
    }
}
</style>
